import { createDebugger } from '@iotize/common/debug';

const prefix = '@iotize/tap/protocol/ble';

export const debug = createDebugger(prefix);
